import { useContext } from "react";

import { UIVersionContext, type UIVersion } from "#contexts";

/**
 * Hook to access the current UI version from the UIVersionProvider.
 *
 * Returns the current UI version ("v1" or "v2") that can be used to
 * conditionally apply styles or render different components.
 *
 * @returns The current UI version
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const version = useUIVersion();
 *
 *   return (
 *     <button
 *       className={version === "v1" ? "mui-button" : "v2-button"}
 *     >
 *       Click me
 *     </button>
 *   );
 * }
 * ```
 */
export function useUIVersion(): UIVersion {
  const context = useContext(UIVersionContext);

  return context.uiVersion;
}
